var host = 'https://dzj.amtb.cn';
//var host = 'http://127.0.0.1:8080';
//var host = '/api';
var config = {

    // 下面的地址配合云端 Demo 工作
    service: {
        host,
        // 登录地址，用于建立会话
        findBookNum: `${host}/mistake/findBookNum.action`,
        findScripttrueTitle: `${host}/mistake/findScripttrueTitle.action`,
        findRollNum: `${host}/mistake/findRollNum.action`,
        findDetail: `${host}/mistake/findDetail.action`,
    }
};

module.exports = config;
